import React from "react";
import "./HimalyanDiamond.css"; // Import your CSS for styling
import prodImg from "../../assets/PackageImages/DaivikGold.png";
import { projects } from "../../data/projectsData";
import {
  Container,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { Link, useParams } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import NutritionalTable from "./NutritionalTable";
import { useMediaQuery, useTheme } from "@mui/material";

const DaivikMix = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const otherProducts = Object.values(projects).flatMap((group, index) =>
    group.map((item) => {
      return { ...item, group: `${index + 1}` };
    })
  );
  const tableData = [
    {
      nutrient: "Protein",
      value: "24%",
    },
    {
      nutrient: "Fat",
      value: "5%",
    },
    {
      nutrient: "Fiber",
      value: "10%",
    },
    {
      nutrient: "Total Diegestable Matter",
      value: "75%",
    },
    {
      nutrient: "Phosphorus",
      value: "0.5%",
    },
    {
      nutrient: "Insoluble Matter",
      value: "Max 2%",
    },
  ];

  return (
    <div className="product-container">
      <div className="product-details">
        <div
          className={
            isMobile ? "product-image product-image--mobile" : "product-image"
          }
        >
          <img
            src={prodImg} // Replace with the actual image path
            alt="Himalaya Diamond Premium"
          />
        </div>
        <div className="product-info">
          <div>
            <div className="product-title">
              DAIVIK MIX{" "}
              <span
                style={{
                  fontFamily: "Playfair Display",
                  fontStyle: "italic",
                  color: "#ffc40c",
                  fontWeight: "bold",
                  fontSize: "1.5rem",
                }}
              >
                (Premium) (Urea - Free)
              </span>{" "}
            </div>

            <div
              style={{
                textAlign: "justify",
              }}
            >
              <p className="bold-description-line">
                <b>High-Performance Dairy Cattle Feed</b>
              </p>
              <p>
                Daivik Mix is a ground cattle feed. It includes guar, wheat
                bran, soybean, cottonseed cake, grains, phosphorus, essential
                cake, vitamins, and probiotics. It is suitable for cows that
                produce 15 to 25 liters of milk. Total Digestible Nutrients This
                cattle feed has the potential to support milk production for 300
                days or more in one lactation and contributes to the health and
                growth of the animal.
              </p>
              <p>
                With a well-balanced blend of protein, fat, fiber, and essential
                nutrients, Dairy Gold provides the nutrition needed to maintain
                steady milk production while promoting overall health and
                vitality in your herd.
              </p>
              <p>
                Made with high-quality ingredients like guar, rice bran,
                molasses, grains, mustard de-oiled cakes, and essential vitamins
                and minerals, Dairy Gold ensures that your cows receive all the
                nutrients they need to thrive.
              </p>
              <p>
                Dairy Gold is the ideal feed for farmers looking to optimize the
                health and productivity of their moderate milk-yielding cows. It
                offers balanced nutrition that supports steady milk production,
                better digestion, and long-term health.
              </p>
            </div>
          </div>
          <div>
            <h3 className="benefits-title">KEY BENEFITS:</h3>
            <div className="benefits">
              <ul>
                <li className="benefit">
                  <div>
                    <b>Scientifically Formulated Feed: </b>A scientifically
                    formulated, complete feed packed with essential nutrients to
                    support optimal milk production and overall animal health.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Rich Blend of Ingredients: </b>A rich blend of
                    ingredients, including guar meal, wheat bran, soybean meal,
                    cottonseed meal, grains, phosphorus, essential oils,
                    vitamins, and probiotics to ensure balanced nutrition.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Maximizes Milk Yield: </b>
                    Specially designed to cater to high-yielding dairy cows
                    producing 15-25 liters of milk per day.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Sustained Lactation: </b>
                    Promotes longer lactation periods, enabling cows to produce
                    milk for over 300 days post-calving.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Enhanced Animal Health: </b>
                    Supports strong immune systems, healthy digestion, and
                    overall well-being of dairy cattle.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Improved Feed Efficiency: </b>
                    Highly digestible formula ensures maximum nutrient
                    absorption, reducing feed wastage.
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <NutritionalTable data={tableData} />
          </div>
        </div>
      </div>

      <div className="other-products">
        <Typography variant="h6" gutterBottom>
          Products Catalogue
        </Typography>
        <List>
          {otherProducts.map((product) => {
            return (
              <ListItem
                key={product.id}
                component={Link}
                to={`/products/${product.id}`}
                style={{
                  borderBottom: "1px lightgray dotted",
                  color: "black",
                  ...(product.id === "Daivik-mix" && {
                    backgroundColor: "#4caf50",
                    color: "white",
                    borderRadius: "1rem",
                  }),
                }}
              >
                <ListItemIcon
                  style={{
                    minWidth: "0px",
                  }}
                >
                  <ArrowForwardIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                  primary={product.title}
                />
              </ListItem>
            );
          })}
        </List>
      </div>
    </div>
  );
};

export default DaivikMix;
